import { cn } from '@/lib/utils';

interface Props {
  name: string;
  isDirect?: boolean;
  tags?: string[];
  signupCount?: number;
  className?: string;
}

const BranchHeader = ({
  name,
  isDirect = false,
  tags = [],
  className,
}: Props) => {
  return (
    <div className={cn('flex items-center gap-4', className)}>
      {/* Left (이름 + 직영점 + 해시태그) */}
      <div className="min-w-0 flex-1">
        <div className="flex flex-col items-start">
          <div className="flex items-center gap-2">
            <h1 className="typo-28 desktop:typo-36 truncate font-black text-gray-900">
              {name}
            </h1>
            {isDirect && (
              <span className="bg-main-yellow text-level-2 typo-14 flex h-[22px] w-[55px] items-center justify-center rounded-sm text-center font-bold">
                직영점
              </span>
            )}
          </div>
          {tags.length > 0 && (
            <div className="mt-4 flex flex-wrap gap-2">
              {tags.map((tag) => (
                <span
                  key={tag}
                  className="bg-bg-grayblue text-font-grayblue typo-16 inline-flex h-9 items-center justify-center rounded-lg px-4 font-medium"
                >
                  #{tag}
                </span>
              ))}
            </div>
          )}
        </div>
      </div>

      {/* Right (누적가입자) */}
      {/* {typeof signupCount === 'number' && (
        <div className="flex justify-center self-center">
          <span className="inline-block rounded-full border border-[#DDDDDD] px-6 py-3 text-lg font-bold text-[#FF5500]">
            누적가입자: {signupCount.toLocaleString()}명
          </span>
        </div>
      )} */}
    </div>
  );
};

export default BranchHeader;
